export class BlockTypeConsts {
  static SCENE_START = 'a-scene-start';
  static AR_SCENE_START = 'ar-a-scene-start';
  static MODEL_VIEW = 'model-viewer';
  static MODEL_VIEW_SIMPLE = 'model-viewer-simple';
  static AR_SCENE_SETTING_ATTRIBUTE = 'ar_scene_setting_attribute_v2';
  static IMAGE_AR_SCENE_SETTING_ATTRIBUTE = 'image_ar_scene_setting_attribute';
  static FACE_AR_SCENE_SETTING_ATTRIBUTE = 'face_ar_scene_setting_attribute';
  static IMAGE_AR_MARKER = 'image_ar_marker';
  static FACE_AR_MARKER = 'face_ar_marker';

  static PHYSICS = 'physics_v2';
  static CUBE = 'cube_v2';
  static SPHERE = 'sphere_v2';
  static TEXT = 'a-text_v2';
  static CAMERA = 'a-camera_v2';
  static CAMERA_V2_1 = 'a-camera_v2.1';
  static ENTITY = 'a-entity_v2';
  static AHEAD = 'ahead';
  static ID = 'id_v2';
  static POSITION = 'position_v2';
  static ROTATION = 'rotation_v2';
  static SPINNING = 'spinning';
  static SIZE_W_H_D = 'size_w_h_d_v2';
  static SCALE = 'scale_v2';
  static COLOR_VALUE = 'color_value_v2';
  static COLOR_ATT = 'color_att_v2';
  static RANDOM_POSITION = 'random-position';
  static RANDOM_SCALE = 'random-scale';
  static RANDOM_COLOR = 'random-color';
  static ENVIRONMENT = 'environment_v2';
  static GRID = 'a-grid';
  static SKY = 'a-sky';
  static OCEAN = 'a-ocean_v2';
  static LIGHT = 'a-light_v2';
  static DYNAMIC_BODY = 'a-dynamic-body_v2';
  static STATIC_BODY = 'a-static-body_v2';
  static AR_CAMERA = 'ar_camera_v2';
  static AR_BARCODE_ATTRIBUTE = 'ar_barcode_attribute_v2';
  static AR_HIRO_ATTRIBUTE = 'ar_hiro_attribute_v2';
  static AR_MARKER = 'ar_marker_v2';
  static LOGIC_RANGE_LOOP = 'logic_range-loop_v2';
  static LOGIC_IF = 'logic_if_v2';
  static LOGIC_IFELSE = 'logic_ifelse_v2';
  static LOGIC_SET_VALUE = 'logic_set_value_v2';
  static LOGIC_EQUAL = 'logic_equal_v2';
  static LOGIC_GREATER_THAN = 'logic_greater_than_v2';
  static LOGIC_LESS_THAN = 'logic_less_than_v2';
  static LOGIC_AND = 'logic_and_v2';
  static LOGIC_ANOR = 'logic_anor_v2';
  static LOGIC_NOT = 'logic_not_v2';
  static LOGIC_FUNCTION_CALL = 'logic_function_call_v2';
  static CONSOLE_ON = 'console_on_v2';
}
